import { render, staticRenderFns } from "./LogoSocial.vue?vue&type=template&id=78212d71"
import script from "./LogoSocial.vue?vue&type=script&lang=js"
export * from "./LogoSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports